// Delivery postcode helpers. The zones themselves come from the backend
// (GET /api/shipping), never from this file.
export const normalizePostal = (value) => String(value || "").replace(/\D/g, "").slice(0, 5);

export const isPostalComplete = (value) => /^\d{5}$/.test(value || "");

export const isPostalValid = (value) => {
  if (!isPostalComplete(value)) return false;
  const province = Number(value.slice(0, 2));
  return province >= 1 && province <= 52;
};

export const isZoneBlocked = (value, prefixes = []) =>
  isPostalComplete(value) && prefixes.some((p) => value.startsWith(p));
